import { render } from "./CorporateSocialResponsibility.vue?vue&type=template&id=47d7df18"
import script from "./CorporateSocialResponsibility.vue?vue&type=script&lang=ts"
export * from "./CorporateSocialResponsibility.vue?vue&type=script&lang=ts"

import "./CorporateSocialResponsibility.vue?vue&type=style&index=0&id=47d7df18&lang=scss"
script.render = render

export default script